// ----------------------------------------------------------------------

export const mockImgCover = (index: number) =>
  `/static/mock-images/covers/cover_${index}.jpg`;

export const mockImgFeed = (index: number) =>
  `/static/mock-images/feeds/feed_${index}.jpg`;

export const mockImgProduct = (index: number) =>
  `/static/mock-images/products/product_${index}.jpg`;

export const mockImgAvatar = (index: number) =>
  `/static/mock-images/avatars/avatar_${index}.jpg`;
